import { render, staticRenderFns } from "./ProjectUnsubscribe.vue?vue&type=template&id=12bc497a&scoped=true&"
import script from "./ProjectUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./ProjectUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUnsubscribe.vue?vue&type=style&index=0&id=12bc497a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc497a",
  null
  
)

export default component.exports